/* eslint-disable no-undef */
import "../../assets/css/mentor.new.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "./filter";
import Search from "./search";
import Details from "./details";
import ReactPaginate from "react-paginate";
import { setData } from "../../utils/helpers/localData";
import { imgPath } from "../../utils/imagePath";
import queryString from "query-string";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { useDispatch, useSelector } from "react-redux";
import { loadMentorsList, saveSelectMentor, saveWaitlistMentor, loadProgrammes } from "./Slice/mentorIgniteSlice";
import PropTypes from "prop-types";

const Index = (props) => {

  const { actions, title } = props;

  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const location = useLocation();
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const dispatch = useDispatch();

  const { mentorsData, pagination, programmes } = useSelector((state) => state?.mentorIgnite);
  const isAuth = useSelector((state) => state.isAuth);
  const userInfo = useSelector((state) => state.userInfo || {});
  const setting = useSelector((state) => state.setting);

  const getMentor = async (e, mentorId) => {
    e.preventDefault();
    if (isAuth === false) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      history(`/login`);
    } else {
      const userId = userInfo.id;
      const request = {};
      request.userId = userId;
      request.mentorId = mentorId;
      try {
        const result = await dispatch(
          saveSelectMentor({
            userId: userInfo.id,
            mentorId,
          })
        ).unwrap();
        setPopupMessage(result?.message || "Mentor has been selected successfully.");
        setShowPopup(true);
      } catch (error) {
        console.error("Failed to select mentor:", error);
      }
    };
  };

  const getUserDetails = (e, {
    full_name,
    image,
    organization,
    position,
    about,
    linkedin,
    main_area,
    mf_mental_health,
    mf_certified_coach,
  }) => {
    e.preventDefault();
    setModalShow(true);
    setUserData({
      full_name,
      image,
      organization,
      position,
      about,
      linkedin,
      main_area,
      mf_mental_health,
      mf_certified_coach,
    });
  };

  const setMentorWaitlistAvailability = async (e, mentorId) => {
    e.preventDefault();
    const userId = userInfo.id;
    const request = {};
    request.userId = userId;
    request.mentorId = mentorId;
    try {
      const result = await dispatch(
        saveWaitlistMentor({
          userId: userInfo.id,
          mentorId,
        })
      ).unwrap();
      setPopupMessage(result?.message ||"Mentor has been added to your waitlist.");
      setShowPopup(true);
    } catch (error) {
      console.error("Failed to waitlist mentor:", error);
    }
  };

  const siteName = setting?.name?.trim() || "Creating impactful connections for women mentees";

  useEffect(() => {
    const title = `${siteName} - Creating impactful connections for women mentees`;

    document.title = title;

    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      const sort = queryStringParsed["sort"];
      const direction = queryStringParsed["direction"];
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      const page = queryStringParsed["page"];
      request.page = page;
    }
    if (params.get("keyword")) {
      const keyword = queryStringParsed["keyword"];
      request.keyword = keyword;
    }
    if (params.get("domains")) {
      const domains = queryStringParsed["domains"];
      request.domains = domains;
    }

    if (params.get("is_available")) {
      const is_available = queryStringParsed["is_available"];
      request.is_available = is_available;
    }

    if (params.get("programmes")) {
      const programmes = queryStringParsed["programmes"];
      request.programmes = programmes;
    }
    if (params.get("mf_mental_health")) {
      const mf_mental_health = queryStringParsed["mf_mental_health"];
      request.mf_mental_health = mf_mental_health;
    }
    if (params.get("mf_certified_coach")) {
      const mf_certified_coach = queryStringParsed["mf_certified_coach"];
      request.mf_certified_coach = mf_certified_coach;
    }

    if (isAuth === true) {
      dispatch(
        loadMentorsList({
          request,
          userId: isAuth ? userInfo.id : 0,
          role: "Mentor",
          domains: "",
        })
      );

    }
    setViewPage(request.page ? request.page - 1 : 0);
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "vLookUp mentors are inspiring and empowering role models, have deep passion for growing talent and believe in fostering diversity."
      );
  }, [siteName, dispatch, title, location, userInfo, isAuth]);

  const history = useNavigate();

  const resetPage = () => {
    history(location?.pathname, { replace: true });
  };

  const searchData = (data) => {
    const params = new URLSearchParams(location.search);
    if (data.keyword) {
      params.set("keyword", data.keyword);
    }
    history({
      pathname: "/mentors",
      search: "?" + params,
    });
  };

  const handleFormClick = (item, action) => {
    actions.loadFormPop(action);
  };

  useEffect(() => {
    dispatch(loadProgrammes());
  }, [dispatch]);

  const [viewPage, setViewPage] = useState(0);
  const handlePageClick = (data) => {
    setViewPage(data.selected);
    let page = data.selected + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history({
      pathname: location?.pathname,
      search: "?" + params,
    });
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isOlayUser = queryParams?.get('is_olay_user');

    if (isOlayUser === 'yes') {
      const referringHostname = 'ai-shu.in';
      const currentDate = new Date();
      const expirationDate = new Date(currentDate);
      expirationDate.setDate(currentDate.getDate() + 7);
      document.cookie = `redirectFrom=${referringHostname}; expires=${expirationDate.toUTCString()}; path=/`;
    }
  }, [])

  const getGlobal = () => {
    if (typeof globalThis !== "undefined") return globalThis;
    return {};
  };

  const handleProgram = () => {
    const g = getGlobal();
    const baseUrl = `${g.location.protocol}//${g.location.host}/`;
    setData("program", "ignite_women_mentoring");
    g.open(`${baseUrl}register`, "_blank");
  };

  const handleLogin = () => {
    const g = getGlobal();
    const baseUrl = `${g.location.protocol}//${g.location.host}/`;
    g.open(`${baseUrl}login`, "_blank");
  };

  return (
    <div >
      <section className='igniteSection'>
        <div className="banner-Cap-outer">
          <Container>
            <div className='banner-Cap'>

              <h1>Welcome to IGNITE <br />Professional Women <br />Network and Mentoring Program</h1>
              <div className='poweredBY'>
                <strong>Powered by</strong>
                <span className='d-inline-block'>
                  <a
                    href="https://www.vlookup.ai/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={setting?.logo_path} alt='logo' style={{ maxWidth: '200px', maxHeight: '59px' }} />
                  </a>
                </span>
              </div>
              <div className="d-none d-lg-block">

                <img src='assets/images/shapeIcon.svg' alt='shapeIcon' />

              </div>
            </div>
          </Container>
        </div>
        <div className='igniteBannerRow'>

          <div className='bannerShapeImg'>
            <img src='assets/images/bannerShapeImg.png' className="d-none d-sm-block" alt='banner' />
            <div className='bannerShapelogo'>
              <a
                href="https://www.ignite-women.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src='assets/images/comShape.png' alt='logo' />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="outer_main mentoring_page">
        <Container className="page_heading text-center mb-5">
          <h1 style={{ fontSize: "24px", fontWeight: "600" }}>
            Be a successful woman in STEM with the right mentors
            {/* Find Your Mentor ({props.pagination.total}){" "} */}
          </h1>
          <div className="col-md-12 mt-3">
            <div className="text-center">
              {
                Object.keys(userInfo)?.length > 0 ? <Link to="/manage-profile" target="_blank" className="btn me-2 mt-3" style={{ padding: '10px 40px' }} >
                  My Dashboard
                </Link> : <>

                  <button onClick={() => handleLogin()}
                    className="btn me-2 mt-3 button-large-style">
                    Login
                  </button>

                  <button
                    onClick={() => handleProgram()}
                    className="btn me-2 mt-3 button-large-style">
                    Register
                  </button>

                  <Link to={{
                    pathname: '/mentors',
                    state: 'ignite-women-mentoring',
                  }} target="_blank" className="btn me-2 mt-3 button-large-style">
                    Browse all vLookUp Mentors
                  </Link></>
              }
            </div>
          </div>
        </Container>
        <div className="page_content">
          <Container>
            <div className="page_content_inner">
              <Search
                onClick={resetPage}
                onSearch={searchData}
                handleFormClick={handleFormClick}
                programmes={programmes}
              />
              <Row>
                <Col id="left_sidebar" md={4} lg={3}>
                  <Filter
                    onClick={resetPage}
                    onSearch={searchData}
                    handleFormClick={handleFormClick}
                  />
                </Col>

                {isAuth && (
                  <Col md={8} lg={9}>
                    <Row className="mentor_list">
                      {/* {mentorsData && */}
                      {mentorsData.map((item, key) => (
                        <Col xs={12} xl={4} lg={4} md={6} sm={6} key={item.id}>
                          <div className="outer position-relative">
                            <div className="mentor_img">
                              {item.image && (
                                <img
                                  src={item.image}
                                  alt="professional consultants for women"
                                />
                              )}
                              {!item.image && (
                                <img
                                  src={
                                    imgPath +
                                    "mentor_women_two.png"
                                  }
                                  alt="professional consultants for women"
                                />
                              )}
                            </div>
                            <div className="mentor_info">
                              <h3>{item.full_name}</h3>
                              <h5>{item.position}</h5>
                              <h5>{item.organization}</h5>
                              <h5>{item.main_area}</h5>
                            </div>
                            <div className="mentor_btn">
                              {" "}
                              <div>
                                {userInfo.role_id !== "Mentor" &&
                                  item.is_relationship === 0 &&
                                  item.is_mentor_terminate === 0 &&
                                  item.is_same_program === 1 && (
                                    <>
                                      {item.is_reached_limit === 0 &&
                                        item.user_availability === 1 ? (
                                        <Link
                                          to=""
                                          onClick={(e) => {
                                            getMentor(e, item.id);
                                          }}
                                        >
                                          Indicate as Preferred Mentor
                                        </Link>
                                      ) : (
                                        <Link
                                          to=""
                                          onClick={(e) => {
                                            setMentorWaitlistAvailability(
                                              e,
                                              item.id
                                            );
                                          }}
                                        >
                                          Waitlist for availability
                                        </Link>
                                      )}
                                    </>
                                  )}
                                <Link
                                  to=""
                                  id={key}
                                  onClick={(e) => {
                                   getUserDetails(e, item);
                                  }}
                                >
                                  {"Read More"}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    {pagination.total_pages && (
                      <ReactPaginate
                        breakLabel={"..."}
                        previousLabel={"<"}
                        nextLabel={">"}
                        forcePage={viewPage}
                        pageCount={pagination.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={(v) => handlePageClick(v)}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    )}
                  </Col>
                )}

                {!isAuth && (
                  <Col md={8} lg={9}>
                    <Row className="mentor_list">
                      {/* {mentorsData && */}
                      {mentorsData.map((item, key) => (
                        <Col xs={12} xl={4} lg={4} md={6} sm={6} key={item.id}>
                          <div className="outer position-relative">
                            <div className="mentor_img">
                              {item.image && (
                                <img
                                  src={item.image}
                                  alt="find a career mentor online"
                                />
                              )}
                              {!item.image && (
                                <img
                                  src={
                                    imgPath +
                                    "mentor_women_two.png"
                                  }
                                  alt="find a career mentor online"
                                />
                              )}
                            </div>
                            <div className="mentor_info">
                              <h3>{item.full_name}</h3>
                              <h6>{item.position}</h6>
                              <h5>{item.organization}</h5>
                              <h5>{item.main_area}</h5>
                            </div>
                            <div className="mentor_btn">
                              {" "}
                              <div>
                                {userInfo.role_id !== "Mentor" && (
                                  <Link
                                    to=""
                                    onClick={(e) => {
                                      getMentor(e, item.id);
                                    }}
                                  >
                                    Indicate as Preferred Mentor
                                  </Link>
                                )}
                                <Link
                                  to=""
                                  id={key}
                                  onClick={(e) => {
                                   getUserDetails(e, item);
                                  }}
                                >
                                  {"Read More"}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    {props.pagination.total_pages && (
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        siblingCount={5}
                        forcePage={viewPage}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={props.pagination.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={(v) => handlePageClick(v)}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    )}
                  </Col>
                )}
              </Row>
            </div>
          </Container>
        </div>
      </section>
      {modalShow && (
        <Details
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div>
  );
};

Index.propTypes = {
  actions: PropTypes.shape({
    loadFormPop: PropTypes.func.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  pagination: PropTypes.shape({
    total_pages: PropTypes.number,
  }).isRequired,
};

export default Index;
